<template>
  <div class="modal fade" :id="dataTarget" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
       aria-hidden="true">
    <div class="modal-dialog" :class="{ 'modal-dialog-centered': centered }" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{ title }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div>{{ context }}</div>
        </div>
        <div class="modal-footer">
          <button v-if="!onlyConfirm" type="button" class="btn btn-secondary" data-dismiss="modal">{{ cancelText }}</button>
          <button type="button" class="btn btn-main-color" data-dismiss="modal">{{ confirmText }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dialog",
  props: {
    dataTarget:{
      type: String,
      default: "exampleModal",
    },
    title: {
      type: String,
      default: "",
    },
    context: {
      type: String,
      default: "",
    },
    cancelText: {
      type: String,
      default: "取消",
    },
    confirmText: {
      type: String,
      default: "確認",
    },
    onlyConfirm: {
      type: Boolean,
      default: false,
    },
    centered: {
      type: Boolean,
      default: false,
    },
  }
}
</script>

<style scoped>

</style>
